import { render } from "./zhendisp.vue?vue&type=template&id=b577931e&scoped=true"
import script from "./zhendisp.vue?vue&type=script&lang=js"
export * from "./zhendisp.vue?vue&type=script&lang=js"

import "./zhendisp.vue?vue&type=style&index=0&id=b577931e&lang=scss&scoped=true"

import exportComponent from "/devops/jenkins_new/jenkins02-node1/workspace/Record_web_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b577931e"]])

export default __exports__